"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompositeRule = void 0;
const RuleFactory_1 = require("./RuleFactory");
/**
 * A rule whose result depends on the result of a list of sub-rules.
 * A sub-rule could be another composite rule, to allow the configuration of complex validation trees.
 * Configuration:
 * type: 'COMPOSITE'
 * algorithm: 'all' | 'any'. If `all`, the all the sub-rules must return `true`, if `any` at least one of the sub-rules ust return `true`
 * subrules: [] The list of sub-rules.
 */
class CompositeRule {
    constructor(config) {
        this.type = () => CompositeRule.NAME;
        this.config = config;
    }
    /**
     * Evaluate the composite rule.
     * @param path
     * @param data
     */
    evaluate(path, data) {
        const validCount = this.config.subRules.reduce((total, ruleConfig) => {
            const validationResult = RuleFactory_1.RuleFactory.create(ruleConfig).evaluate(path, data);
            return total + (validationResult.valid ? 1 : 0);
        }, 0);
        const result = { valid: true };
        if (this.config.algorithm === 'any') {
            result.valid = validCount > 0;
        }
        else {
            result.valid =
                validCount === this.config.subRules.length;
        }
        if (!result.valid) {
            result.field = path;
            result.message = this.config.errorMessage || `${path} is not valid`;
        }
        return result;
    }
}
exports.CompositeRule = CompositeRule;
CompositeRule.NAME = 'COMPOSITE';
//# sourceMappingURL=CompositeRule.js.map